<div class="wrapper">
  <div class="box">
    <h1>401</h1>
    <p>Sorry, you are not authorized to view this page.</p>
  </div>
</div>
